import { T } from "../../utils/I18n/I18n"
import loadable from '@loadable/component';
    import React, { useState } from 'react';
    import { Link } from 'react-router-dom';
    import { useAccountPopup } from '../../hooks/useAccountPopup';
    import { useMobileSearch } from '../../hooks/useMobileSearch';
    import './Header.scss';
import Logo from './Logo/Logo'
import {useConfig} from "../../context/ConfigContext";

const Search = loadable(() => import('./Search/Search'), {ssr: true});
const MenuNavbar = loadable(() => import('./MenuNavbar/MenuNavbar'), {ssr: true});
const HeaderMyAccount = loadable(() => import('./HeaderMyAccount/HeaderMyAccount'), {ssr: false});
const HeaderMiniCart = loadable(() => import('./HeaderMiniCart/HeaderMiniCart'), {ssr: false});


const Header = () => {
    const { config } = useConfig();
    const country = config?.countryCode;
    const isRs = country?.includes('RS');
    const { hideAccPopup } = useAccountPopup();
    const { showSearch, hideSearch, toggleSearch } = useMobileSearch();
    const [isMenuExpanded, setIsMenuExpanded] = useState(false);


  return (
      <header className="header">
        <div className="header__wrapper">
          <div className="header__logo">
            <Link to="/">
              <Logo className="header__logo-pic"  alt="logo" />
            </Link>
          </div>
            <div className={`header__search ${showSearch ? 'header__search--visible' : ''}`}>
                <Search hideSearch={hideSearch} />
            </div>
            <div className="header__menu">
                <div
                    className="header__menu-item header__menu-item_menu"
                    onClick={() => setIsMenuExpanded(!isMenuExpanded)}
                />

                <div
                    className="header__menu-item header__menu-item_search"
                    onClick={() => {
                        toggleSearch();
                        hideAccPopup();
                    }}
                >
                    <img src="https://s3.emmezeta.hr/falcon/header-icon-loupe.svg" alt="search" />
                </div>

                <Link
                    to={`/kontakt-i-usluge/lokacije-${isRs ? 'centara' : 'trgovina'}`}
                    className="header__menu-item header__menu-item_locations"
                >
                    <img className="header__locations-pic" src="https://s3.emmezeta.hr/falcon/header-icon-pin-stores.svg" alt="locations" />
                    <span className="header__locations-text">
              <T id="header.contacts" />
            </span>
                </Link>

                <HeaderMyAccount />

                <HeaderMiniCart />
            </div>
        </div>
          <MenuNavbar isMenuExpanded={isMenuExpanded} setIsMenuExpanded={setIsMenuExpanded} />
      </header>
          )

};

export default React.memo(Header);
/*
Zamknięcie zakomentowanego bloku kodu return
*/
